<template>
    <div>
        <v-dialog v-model="exportreportdialog" max-width="600px">

      <template v-slot:activator="{ on }">
                   <v-row>
          <v-col cols="1">
            <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
          </v-col>

          <v-col>
          </v-col>
          <v-col cols="auto" style="display:flex; align-items:center; gap:8px;">
            <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
              PDF
            </button>
            <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
              CSV
            </button>
            <div class="gv-search">
              <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
            </div>
          </v-col>        
        </v-row>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline mb-4">Relationship Record</span>
            </v-card-title>

            <v-card-text>
              <v-container>

                  <v-row>
                       <v-col cols="12" class="mt-n8">
                        <v-text-field
                            outlined
                            background-color="#ffeab2"
                            readonly
                            :label="this.$t('setupreport_exportmapping.maptypedesc')"
                            type="text"
                            v-model="selections[0].maptypedesc"
                            dense
                        ></v-text-field>
                    </v-col>
                  </v-row>
                   
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupreport_exportmapping.internalcode')"
                                type="text"
                                ref="intcode"
                                :rules="[rules.required]"
                                :items="relationshipList"
                                clearable
                                hide-selected
                                v-model="selections[0].intcode"
                                @change="changeRelationshipHandler(selections[0].intcode)"
                                dense
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                dense
                                :label="this.$t('setupreport_exportmapping.internaldesc')"
                                outlined
                                readonly
                                background-color="#ffeab2"
                                v-model="selections[0].intdesc"
                            ></v-text-field>
                        </v-col>
                 </v-row>           

                     <v-row>

                      <v-col cols="12" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('setupreport_exportmapping.externalcode')"
                            type="text"
                            v-model="selections[0].extcode"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>

                     </v-row>

                     
                     <v-row>

                      <v-col cols="12" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('setupreport_exportmapping.externaldesc')"
                            type="text"
                            v-model="selections[0].extdesc"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>

                     </v-row>
             
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions style="padding: 8px 24px 16px;">
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeExportreportInput">{{$t('button.cancel')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveExportreportInput">{{$t('button.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1 reportmap-table"
            :search="search"
            fixed-header
            :sort-by="['code']"
        >
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>

        </v-data-table>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';
//import GenericForm from '../../generic/GridForm';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       // 'app-genericform': GenericForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            exportreportdialog: false,
            editDialog: false,
            detailItem: this.parentObject.detailItem,
            maptypeid: this.parentObject.maptypeid,
         
            selections: [{
               // clmtypeid: null,
                id: null,
                maptypeid: null,
                maptypedesc: null,
                intcode: null,
                intdesc: null,
                extcode: null,
                extdesc:null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 0,
                userid: this.$store.getters.userId,
            }],
            
            relationship:[],
            relationshipList: [],
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
            search: '',
            maptypes: [],
        }
    },

    methods: {
        compareArray,

newItem() {
    this.isExisting = false;
    this.modify = false;
    this.resetSelections();
},

        printPDF() {
            const doc = new (require('jspdf').jsPDF)({ orientation: 'landscape' });
            const headers = this.parentObject.tabHeader
                .filter(h => h.value !== 'action')
                .map(h => ({ title: h.text, dataKey: h.value }));
            const body = this.detailItem.map(item =>
                headers.reduce((o, h) => { o[h.dataKey] = item[h.dataKey] || ''; return o; }, {})
            );
            doc.text('Relationship', 10, 10);
            doc.autoTable({ head: [headers.map(h => h.title)], body: body.map(r => Object.values(r)), startY: 20, styles: { fontSize: 7, cellPadding: 1 } });
            doc.save('Relationship.pdf');
        },

        objectToCSV(data) {
            if (!data || !data.length) return '';
            const headers = Object.keys(data[0]);
            const rows = data.map(row => headers.map(h => `"${('' + (row[h] || '')).replace(/"/g, '\\"')}"`).join(','));
            return [headers.join(','), ...rows].join('\n');
        },

        download(data, filename) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('hidden', '');
            a.setAttribute('href', url);
            a.setAttribute('download', filename);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        getCSV() {
            const cols = this.parentObject.tabHeader.filter(h => h.value !== 'action');
            const data = this.detailItem.map(item =>
                cols.reduce((o, h) => { o[h.text] = item[h.value] || ''; return o; }, {})
            );
            this.download(this.objectToCSV(data), 'Relationship.csv');
        },

        loadMapTypeList(){

            const vm = this;

            this.$store.dispatch('get', {
                url:  '/maptype/' + this.parentObject.maptypeid})
                .then(res => {
                    vm.maptypes = res.data.rec;

                    this.selections[0].maptypedesc = res.data.rec[0].maptypedesc;
                    this.selections[0].maptypeid = res.data.rec[0].id;
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });

        },

         loadRelationship() {
           const vm = this;

            this.$store.dispatch('get', {
                url:  '/membertype/all'})
                .then(res => {
                    vm.relationship = res.data.rec;

                    for (let i = 0; i < vm.relationship.length; i++) {
                    vm.relationshipList.push({
                        text: res.data.rec[i].memberdesc,
                        code: res.data.rec[i].memberdesc,
                        value: res.data.rec[i].memberdesc,
                        
                    });
                }

                 if (vm.selections[0].intcode){
                         vm.changeRelationshipHandler(vm.selections[0].intcode);
                     }

                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });

    
        },

        changeRelationshipHandler(memberdesc) {
              var item = this.relationship.find(item => item.memberdesc === memberdesc);

              this.selections[0].intcode = item.memberdesc;
              this.selections[0].intdesc = item.memberdesc;
        },


       modifyItemHandler(item) {
            // assign loaded data to selections array
            if(item.action == 1) {
                this.modify = true;    
            }
            if(item.action == 2) {
                this.isExisting = true;    
            }

           // this.itemHolder = item
            this.selections[0] =  item;

            this.exportreportdialog = true;
        },

        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);

            this.detailItem.splice(itemIndex, 1);
        },

        saveExportreportInput() {
            if (this.selections[0].intcode == null ) {
                 this.$dialog.alert(this.$t('setupreport_exportmapping.intcodemessage')).then((dialog) => {
                console.log(dialog);
             });
             }
              else if(this.selections[0].intdesc == null) {
                 this.$dialog.alert(this.$t('setupreport_exportmapping.intdescmessage')).then((dialog) => {
                console.log(dialog);
             });}
             else if (this.selections[0].extcode == null){
                 this.$dialog.alert(this.$t('setupreport_exportmapping.extcodemessage')).then((dialog) => {
                console.log(dialog);
             });
             } else if (this.selections[0].extdesc == null ){

              this.$dialog.alert(this.$t('setupreport_exportmapping.extdescmessage')).then((dialog) => {
                console.log(dialog);
             });
            } else {

            if (!this.isExisting && this.modify) {
                this.resetSelections();
            } else if (!this.isExisting) {
                this.selections[0].id = null;
                this.selections[0].action = 1;

                this.detailItem.push(Object.assign({}, this.selections[0]));
            } else {
                if (this.compareArray(this.detailItem, this.selections[0])) {
                console.log(this.compareArray(this.detailItem, this.selections[0]));
                }
            }
          //  }

            this.$emit('input', this.detailItem);
            this.exportreportdialog = false;
            

            // reset the form fields
            this.resetSelections();
            }
      
        },

        closeExportreportInput() {
            this.exportreportdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },
        // Saving wizardsetup details into wizardsetupd
        saveTaskHandler() {

            this.isErr = false;

            if (!this.isExisting) {
                this.selections[0].id = null;
                this.selections[0].action = 1;

                this.detailItem.push(Object.assign({}, this.selections[0]));
            } else {
                if (this.compareArray(this.detailItem, this.selections[0])) {
                    console.log(this.compareArray(this.detailItem, this.selections[0]))
                }
                
            }
            
            this.$emit('input', this.detailItem);
            //this.seqnoHandler();
            this.exportreportdialog = false;

            // reset the form fields
            this.resetSelections();
        
        },


        resetSelections() {
            console.log('select', this.selections)
            this.selections = [{
               // clmtypeid: this.selections[0].clmtypeid,
                id: null,
                maptypeid: this.parentObject.maptypeid,
                maptypedesc: this.selections[0].maptypedesc,
                intcode: null,
                intdesc: null,
                extcode: null,
                extdesc:null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 0,
                userid: this.$store.getters.userId,
            }]

          //  console.log('lm1373', this.selections)
        },          
    },

    created() {

    this.loadRelationship();
    this.loadMapTypeList();
      
  
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
.reportmap-table .v-data-table__wrapper {
  overflow-x: auto !important;
}
.reportmap-table .v-data-table__wrapper table {
  min-width: 600px;
}
.gv-search { position: relative; display: inline-flex; align-items: center; }
.gv-search-icon { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.gv-search-input { padding: 5px 10px 5px 30px; border: 1.5px solid #E8EDF5; border-radius: 8px; font-size: 0.83rem; font-family: inherit; color: #1E293B; outline: none; width: 180px; background: #fff; }
.gv-search-input:focus { border-color: #4F6BFF; box-shadow: 0 0 0 3px rgba(79,107,255,0.10); }
</style>